import React, { useEffect, useState } from "react";
import Card from "components/Card/Card";
import "../../styles/styles.css";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;
const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: { "Content-Type": "application/json" },
});

interface PageEvenementsProps {
  nombre?: number; // paramètre optionnel
}

const PageEvenements: React.FC<PageEvenementsProps> = ({ nombre }) => {
  const [evenements, setEvenements] = useState<any[]>([]);

  useEffect(() => {
    const getEvenements = async () => {
      try {
        const response = await axiosInstance.get("api/articles/Évenements");

        // 🔥 Trie décroissant par createdAt (du plus récent au plus ancien)
        const sorted = response.data.sort(
          (a: any, b: any) =>
            new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
        );

        setEvenements(sorted);
      } catch (error) {
        console.log("erreur:" + error);
      }
    };
    getEvenements();
  }, []);

  // Si nombre est défini, on ne prend que les `nombre` premiers événements
  const displayedEvenements = nombre ? evenements.slice(0, nombre) : evenements;

  return (
    <div className="stretch bgColor">
      <div className="container py-3 lg:py-4">
        {/* HEADER */}
        <h2 className="inline-block align-middle text-4xl font-semibold md:text-5xl">
          Événements
        </h2>

        {/* TEXTE + BOUTON */}
        {nombre ? (
          <div className="flex items-center gap-3 mt-0">
            <span className="text-black">Les {displayedEvenements.length} plus récents événements</span>
            <a
              href="/evenements"
              className="inline-block px-3 py-1 text-white bg-primary-6000 rounded-full hover:bg-primary-700 transition-colors duration-200 text-sm"
            >
              Voir plus d’événements
            </a>
          </div>
        ) : (
          <span className="text-black block mt-0">
            {evenements.length} événements
          </span>
        )}
        {/* ====================== END HEADER ====================== */}

        <div className="mt-0 flex flex-col sm:items-center sm:justify-between sm:flex-row">
          <div className="block border-b w-full border-neutral-500 sm:hidden"></div>
          <div className="flex justify-end"></div>
        </div>

        {/* LOOP ITEMS */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-3 gap-y-4 md:gap-x-4 md:gap-y-5 mt-4 lg:mt-5">
          {displayedEvenements.map((post) => (
            <Card key={post._id} post={post} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default PageEvenements;
